import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Project } from '@simultrain/shared';
import { api } from '../api/client.js';

export function ProjectsPage() {
  const { t } = useTranslation();
  const [projects, setProjects] = useState<Project[] | null>(null);
  const [creating, setCreating] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function reload() {
    try {
      setProjects(await api.listProjects());
    } catch (e) {
      setError(String(e));
    }
  }

  useEffect(() => {
    void reload();
  }, []);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await api.createProject({ name, description });
      setName('');
      setDescription('');
      setCreating(false);
      await reload();
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div>
      <div className="row" style={{ justifyContent: 'space-between', marginBottom: 16 }}>
        <h2>{t('projects.title')}</h2>
        <button onClick={() => setCreating((v) => !v)}>+ {t('projects.create')}</button>
      </div>

      {error && <div className="error-banner">{error}</div>}

      {creating && (
        <form onSubmit={create} className="card">
          <div style={{ marginBottom: 12 }}>
            <label>{t('projects.name')}</label>
            <input value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label>{t('projects.description')}</label>
            <textarea value={description} onChange={(e) => setDescription(e.target.value)} />
          </div>
          <button type="submit">{t('projects.create')}</button>
        </form>
      )}

      {projects === null ? (
        <div className="empty">…</div>
      ) : projects.length === 0 ? (
        <div className="empty">{t('projects.empty')}</div>
      ) : (
        <div>
          {projects.map((p) => (
            <Link to={`/projects/${p.id}`} key={p.id} style={{ textDecoration: 'none' }}>
              <div className="card">
                <h2>{p.name}</h2>
                <div className="muted">{p.description || '—'}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
